module.exports = __webpack_public_path__ + "static/media/trainings_sunset_mind_body_fitness.c0fc0ff1.webp";